import Vue from 'vue'
import Router from 'vue-router'
// import Home from '@/components/home'
// import Account from '@/components/account'
// import FirstPageReg from '@/components/login/firstPageReg'
// import NonCustContact from '@/components/login/nonCustContact'
// import Login from '@/components/login/login'
// import ChangePassword from '@/components/login/changePassword'
// import Lghead from '@/components/request/lghead'
// import Lgmain from '@/components/request/lgmain'
// import AppHistory from '@/components/apphistory/apphistory'
// import Disclaimer from '@/components/disclaimer/disclaimer'
// import TaskList from '@/components/task/taskList'
// import TaskHistoryList from '@/components/task/taskHistoryList'
import store from '../store'

Vue.use(Router)

const Home = () => import(/* webpackChunkName: "home" */  '@/components/home')
const Account = () => import(/* webpackChunkName: "account" */  '@/components/account')
const FirstPageReg = () => import(/* webpackChunkName: "page-reg" */ '@/components/login/firstPageReg')
const NonCustContact = () => import(/* webpackChunkName: "noncustcontact" */ '@/components/login/nonCustContact')
const Login = () => import(/* webpackChunkName: "login" */ '@/components/login/login')
const ChangePassword = () => import(/* webpackChunkName: "changepwd" */'@/components/login/changePassword')
const Lghead = () => import(/* webpackChunkName: "lg-head" */ '@/components/request/lghead')
const Lgmain = () => import(/* webpackChunkName: "lg-main" */ '@/components/request/lgmain')
const AppHistory = () => import(/* webpackChunkName: "app-history" */ '@/components/apphistory/apphistory')
const Disclaimer = () => import(/* webpackChunkName: "disclaimer" */ '@/components/disclaimer/disclaimer')
const TaskList = () => import(/* webpackChunkName: "task-list" */ '@/components/task/taskList')
const TaskHistoryList = () => import(/* webpackChunkName: "task-history-list" */ '@/components/task/taskHistoryList')
const LgSearch = () => import(/* webpackChunkName: "lg-search" */ '@/components/nhso/lgsearch')

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next()
    return
  }
  next('/')
}

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next()
    return
  }
  next('/login')
}

const router = new Router({
  //mode: 'history',
  //base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Home',
      component: FirstPageReg,
    },
    {
      path: '/firstPageReg',
      name: 'FirstPageReg',
      component: FirstPageReg,
    },
    {
      path: '/nonCustContact',
      name: 'NonCustContact',
      component: NonCustContact,
    },
    {
      path: '/account',
      name: 'Account',
      component: Account,
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/request',
      name: 'Lghead',
      component: Lghead,
      beforeEnter: ifAuthenticated,
    },       
    {
      path: '/disclaimer',
      name: 'Disclaimer',
      component: Disclaimer,
      beforeEnter: ifAuthenticated,
    },    
    {
      path: '/apphistory',
      name: 'AppHistory',
      component: AppHistory,
      beforeEnter: ifAuthenticated,
    },        
    {
      path: '/login',
      name: 'Login',
      component: Login,
    },
    {
      path: '/changePassword',
      name: 'ChangePassword',
      component: ChangePassword,
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/lgmain',
      name: 'Lgmain',
      component: Lgmain,
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/taskList',
      name: 'TaskList',
      component: TaskList,
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/taskHistoryList',
      name: 'TaskHistoryList',
      component: TaskHistoryList,
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/lgsearch',
      name: 'LgSearch',
      component: LgSearch,
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/send-email',
      name: 'SendEmail',
      component: () => import(/* webpackChunkName: "send-email" */ '@/components/SendEmail'),
      props: (route) => ({ code: route.query.code, type: route.query.type }),
    },
  ],
})

export default router
var loader;
router.beforeEach((to, from, next) => {

  loader = Vue.$loading.show();

  next()
})

router.afterEach((to, from) => {

  loader.hide();

})
